const pagePathList = [
  // PC
  {
    // 퀙메뉴 > 장바구니
    name: "orderBasket",
    mobile: false,
    type: "page",
    path: "/paintpro/orderBasket",
    query: { menu1: "orderList", menu2: "base" },
  },
  {
    // 퀙메뉴 > 최근본 상품
    name: "rcentlyViewedProd",
    mobile: false,
    type: "page",
    path: "/paintpro/quickMenu/rcentlyViewedProd",
    query: { menu1: "prodList", menu2: "base" },
  },
  {
    // 퀙메뉴 > 페인트양 계산하기기
    name: "paintValueCalc",
    mobile: false,
    type: "popup",
    path: "isPaintValueCalc",
    query: {},
  },
  {
    // 퀙메뉴 > 원격지원
    name: "remoteSupport",
    mobile: false,
    type: "popup",
    path: "isRemoteSupport",
    query: {},
  },
  {
    // 퀙메뉴 > 동영상 가이드
    name: "movieGuide",
    mobile: false,
    type: "popup",
    path: "isMovieGuide",
    query: {},
  },
  {
    // 퀙메뉴 > 사용자 메뉴얼
    name: "userManual",
    mobile: false,
    type: "popup",
    path: "isUserManual",
    query: {},
  }, // MO
  {
    // 퀙메뉴 > 장바구니
    name: "orderBasket",
    mobile: true,
    type: "page",
    path: "/paintpro/orderBasket",
    query: { menu1: "orderList", menu2: "base" },
  },
  {
    // 퀙메뉴 > 최근본 상품
    name: "rcentlyViewedProd",
    mobile: true,
    type: "page",
    path: "/paintpro/quickMenu/rcentlyViewedProd",
    query: { menu1: "prodList", menu2: "base" },
  },
  {
    // 퀙메뉴 > 페인트양 계산하기기
    name: "paintValueCalc",
    mobile: true,
    type: "popup",
    path: "isPaintValueCalc",
    query: {},
  },
  {
    // 퀙메뉴 > 원격지원
    name: "remoteSupport",
    mobile: true,
    type: "popup",
    path: "isRemoteSupport",
    query: {},
  },
  {
    // 퀙메뉴 > 동영상 가이드
    name: "movieGuide",
    mobile: true,
    type: "popup",
    path: "isMovieGuide",
    query: {},
  },
  {
    // 퀙메뉴 > 사용자 메뉴얼
    name: "userManual",
    mobile: true,
    type: "popup",
    path: "isUserManual",
    query: {},
  },
];

const breadcrumbList = [
  {
    menu1: "zsample",
    menu2: "zsample06",
    info: [
      { name: "zsample", path: "/paintpro/zsample" },
      { name: "zsample01", path: "/paintpro/zsample/zsample01" },
    ],
  },
];

// 페이지 링크정보 가져오기
const getPagePath = (name) => {
  return pagePathList.find((ele) => ele.name === name);
};

const getBreadcrumb = (menu1, menu2) => {
  let _item = null;
  if (menu1 && menu2) {
    _item = breadcrumbList.find(
      (ele) => ele.menu1 === menu1 && ele.menu2 === menu2
    );
  } else if (menu1) {
    _item = breadcrumbList.find(
      (ele) => ele.menu1 === menu1 && ele.menu2 === "-"
    );
  } else {
    return null;
  }
  if (_item) {
    return _item.info;
  }
  return [];
};

export default {
  getPagePath,
  getBreadcrumb,
};
